import type { Statistics } from '../types.js';

import { console } from '../../../../../../../core/system/console/index.js';

export const registerPollAnswer = async (
  id: string,
  answer: string,
): Promise<Statistics | null> => {
  try {
    const response = await fetch(
      `/api/quiz/answers/${id}/${answer}?withTotals=true`,
      {
        method: 'PUT',
      },
    );

    if (!response.ok) {
      throw new Error(`[Quiz API] Failed to register answer for poll ${id}`);
    }

    const data = await response.json();

    return {
      ...(data as Statistics),
      lastUpdated: new Date().getTime(),
    };
  } catch (error) {
    console.error(error);

    return null;
  }
};
